import React from "react";
import { Compass, Boxes, TrendingUp, ShieldCheck, Route, CheckCircle2, Circle, CircleDot } from "lucide-react";
import { cn } from "../../lib/utils";

const AREA_ICON = { compass: Compass, boxes: Boxes, "trending-up": TrendingUp, shield: ShieldCheck, route: Route };
export const AreaIcon = ({ icon, ...p }) => React.createElement(AREA_ICON[icon] || Compass, p);

// Plain text with **bold** spans.
export function Rich({ text, className }) {
  const parts = String(text).split(/(\*\*[^*]+\*\*)/g);
  return (
    <span className={className}>
      {parts.map((p, i) => (p.startsWith("**") ? <strong key={i} className="font-semibold text-fg">{p.slice(2, -2)}</strong> : p))}
    </span>
  );
}

export function StatusIcon({ done, active, size = 13 }) {
  if (done) return <CheckCircle2 size={size} className="text-success shrink-0" aria-label="Completed" />;
  if (active) return <CircleDot size={size} className="text-primary shrink-0" />;
  return <Circle size={size} className="text-subtle/70 shrink-0" />;
}

export function Meter({ done, total, className, testid }) {
  const pct = total ? Math.round((done / total) * 100) : 0;
  return (
    <div data-testid={testid} className={cn("h-1.5 bg-surface-2 border border-border/60 rounded-full overflow-hidden", className)}
         role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
      <div className="h-full bg-primary transition-[width] duration-700 ease-out" style={{ width: `${pct}%` }} />
    </div>
  );
}

export const Eyebrow = ({ children, className }) => (
  <div className={cn("text-[10.5px] font-semibold uppercase tracking-[0.2em] text-primary", className)}>{children}</div>
);
